// const remotesUrl = 'http://pgs.mecoolchina.com/';
const remotesUrl = 'http://jboss.remotes.myfmes.cn:8083/';

export default {
  remotesUrl
}



// WEBPACK FOOTER //
// ./src/global/global.js